import React from "react";
import { Box, Typography, IconButton, Badge, useMediaQuery, useTheme, Skeleton } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const Header = ({ publicData, branch, cartCount, onCartOpen, getImageUrl }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

const placeholderHeader = "https://via.placeholder.com/1200x300?text=Header+Image";

const banner = publicData?.data?.data?.banner_image || publicData?.banner_image || null;
const headerImage = getImageUrl(banner, placeholderHeader);
  // جلب اللوجو من publicData
  const logo = publicData?.data?.data?.logo || publicData?.logo || null;
  const logoUrl = logo ? getImageUrl(logo, "https://cdn-icons-png.flaticon.com/512/3132/3132693.png") : "https://cdn-icons-png.flaticon.com/512/3132/3132693.png";
  
  return (
    <>
      {/* صورة الهيدر - محسّنة للهاتف */}
      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          borderBottom: "2px solid #ffe0b2",
          bgcolor: "#f5f5f5",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={headerImage}
          alt="Header"
  onError={(e) => {
  e.currentTarget.src = placeholderHeader;
}}
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            maxHeight: { xs: 200, sm: 300, md: 400 },
            objectFit: "contain",
            objectPosition: "center",
            bgcolor: "#f5f5f5",
          }}
        />
      </Box>

      {/* شريط بيانات الفرع والسلة */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "#fffbe6",
          borderBottom: "2px solid #ffe0b2",
          px: { xs: 1.5, sm: 3, md: 8 },
          py: { xs: 1, sm: 1.5, md: 2 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 1, sm: 2 },
          boxShadow: "0 2px 12px 0 #ffe0b222",
          position: "sticky",
          top: 0,
          zIndex: 1100,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 } }}>
          {logo ? (
            <Box
              component="img"
              src={logoUrl}
              alt="logo"
              onError={(e) => {
                console.error("فشل تحميل اللوجو");
                e.target.src = "https://cdn-icons-png.flaticon.com/512/3132/3132693.png";
              }}
              sx={{
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                borderRadius: { xs: 1.5, sm: 2 },
                bgcolor: "#fff",
                boxShadow: "0 2px 8px #ffb30022",
                objectFit: "contain",
                p: 0.5,
              }}
            />
          ) : publicData ? (
            <Box
              component="img"
              src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png"
              alt="default logo"
              sx={{
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                borderRadius: { xs: 1.5, sm: 2 },
                bgcolor: "#fff",
                boxShadow: "0 2px 8px #ffb30022",
                objectFit: "contain",
                p: 0.5,
              }}
            />
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                borderRadius: { xs: 1.5, sm: 2 },
              }}
            />
          )}
          <Box>
            <Typography
              sx={{
                fontWeight: 900,
                color: "#ff3d3d",
                fontSize: { xs: 16, sm: 18, md: 20 },
                lineHeight: 1.2,
              }}
            >
              {branch?.name || ""}
            </Typography>
            {branch?.address && !isMobile && (
              <Typography sx={{ color: "#888", fontSize: { sm: 13, md: 14 }, lineHeight: 1.2 }}>
                {branch.address}
              </Typography>
            )}
          </Box>
        </Box>
        <IconButton
          color="inherit"
          onClick={onCartOpen}
          sx={{
            bgcolor: "#fff",
            border: "2px solid #ffb300",
            color: "#ffb300",
            boxShadow: "0 2px 8px #ffb30033",
            width: { xs: 42, sm: 48 },
            height: { xs: 42, sm: 48 },
            transition: "background 0.2s, color 0.2s, border 0.2s",
            "&:hover": {
              bgcolor: "#ffb300",
              color: "#fff",
              border: "2px solid #ffb300",
            },
          }}
        >
          <Badge badgeContent={cartCount} color="error">
            <ShoppingCartIcon sx={{ fontSize: { xs: 22, sm: 26, md: 28 } }} />
          </Badge>
        </IconButton>
      </Box>
    </>
  );
};

export default Header;
